export class Login {
  constructor(
    public email: string,
    public password: string
  ) {  }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/login/login.ts
 **/